import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import Loading from 'vue-loading-overlay';

import VeeValidate from 'vee-validate';
import BootstrapVue from 'bootstrap-vue';
import { BAlert } from 'bootstrap-vue';
import Vuetify from 'vuetify';
import datePicker from 'vue-bootstrap-datetimepicker';
import excel from 'vue-excel-export';

// Import stylesheet
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';

Vue.use(datePicker);
Vue.use(excel);

Vue.use(Vuetify, {
iconfont: "md"
});

Vue.component('b-alert', BAlert);
// Vue.use(VeeValidate);
Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields'
});
Vue.use(Loading);
Vue.use(BootstrapVue);

Vue.config.productionTip = false;
if(localStorage.getItem('isLoggedIn')){
  store.state.isLoggedIn =  localStorage.getItem('isLoggedIn') ? true : false;
}
if(localStorage.getItem('isAdmin')){
  let localValue = localStorage.getItem('isAdmin');
  if(localValue == "true"){
    store.state.isAdmin = true;
  }else{
    store.state.isAdmin = false;
  }
}

new Vue({
  router,
  store,
  render: (h) => h(App),
  vuetify: new Vuetify(),
}).$mount('#app');

